// Trust strip showing accepted payment methods.
// Uses inline SVGs (no third-party network calls, no image flicker).
// Each badge has a fixed aspect so renders crisp on every density.

const Visa = () => (
  <svg viewBox="0 0 60 36" preserveAspectRatio="xMidYMid meet" className="h-6 sm:h-7 w-[60px] sm:w-[70px]" aria-label="Visa">
    <rect width="60" height="36" rx="4" fill="#1A1F71" />
    <text x="30" y="24" textAnchor="middle" fontFamily="Arial Black, Arial, sans-serif" fontWeight="900" fontStyle="italic" fontSize="15" fill="#FFFFFF">VISA</text>
  </svg>
);

const Mastercard = () => (
  <svg viewBox="0 0 60 36" preserveAspectRatio="xMidYMid meet" className="h-6 sm:h-7 w-[60px] sm:w-[70px]" aria-label="Mastercard">
    <rect width="60" height="36" rx="4" fill="#FFFFFF" />
    <circle cx="24" cy="18" r="10" fill="#EB001B" />
    <circle cx="36" cy="18" r="10" fill="#F79E1B" />
    <path d="M30 11.1a10 10 0 0 1 0 13.8 10 10 0 0 1 0-13.8z" fill="#FF5F00" />
  </svg>
);

const Amex = () => (
  <svg viewBox="0 0 60 36" preserveAspectRatio="xMidYMid meet" className="h-6 sm:h-7 w-[60px] sm:w-[70px]" aria-label="American Express">
    <rect width="60" height="36" rx="4" fill="#006FCF" />
    <text x="30" y="17" textAnchor="middle" fontFamily="Arial Black, Arial, sans-serif" fontWeight="900" fontSize="7" fill="#FFFFFF">AMERICAN</text>
    <text x="30" y="27" textAnchor="middle" fontFamily="Arial Black, Arial, sans-serif" fontWeight="900" fontSize="7" fill="#FFFFFF">EXPRESS</text>
  </svg>
);

const Mada = () => (
  <svg viewBox="0 0 60 36" preserveAspectRatio="xMidYMid meet" className="h-6 sm:h-7 w-[60px] sm:w-[70px]" aria-label="Mada">
    <rect width="60" height="36" rx="4" fill="#FFFFFF" stroke="#E0E0E0" strokeWidth="0.5" />
    <text x="30" y="25" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="900" fontSize="13" fill="#231F20">mada</text>
    <rect x="13" y="10" width="9" height="2.5" fill="#84B740" />
    <rect x="38" y="10" width="9" height="2.5" fill="#005EA8" />
  </svg>
);

// KNET — Kuwait's national debit card scheme.
const Knet = () => (
  <svg viewBox="0 0 60 36" preserveAspectRatio="xMidYMid meet" className="h-6 sm:h-7 w-[60px] sm:w-[70px]" aria-label="KNET">
    <rect width="60" height="36" rx="4" fill="#FFFFFF" stroke="#E0E0E0" strokeWidth="0.5" />
    <text x="30" y="23" textAnchor="middle" fontFamily="Arial Black, Arial, sans-serif" fontWeight="900" fontSize="13" fill="#0A5C36">K-NET</text>
    <rect x="11" y="27" width="38" height="2" fill="#0A5C36" />
    <rect x="11" y="7" width="38" height="2" fill="#C8161D" />
  </svg>
);

// Apple Pay — official mark, sized to match the other card badges exactly.
const ApplePay = () => (
  <span
    className="h-6 sm:h-7 w-[60px] sm:w-[70px] inline-flex items-center justify-center bg-black rounded-[4px]"
    aria-label="Apple Pay"
  >
    <img
      src="/payment-logos/applepay.png"
      alt="Apple Pay"
      className="h-3 sm:h-3.5 w-auto"
      style={{ filter: "invert(1)" }}
      draggable={false}
    />
  </span>
);

// Google Pay — official mark, sized to match the other card badges exactly.
const GooglePay = () => (
  <span
    className="h-6 sm:h-7 w-[60px] sm:w-[70px] inline-flex items-center justify-center bg-white border border-[#DADCE0] rounded-[4px]"
    aria-label="Google Pay"
  >
    <img
      src="/payment-logos/gpay.png"
      alt="Google Pay"
      className="h-3 sm:h-3.5 w-auto"
      draggable={false}
    />
  </span>
);

export default function PaymentBadges({ className = "", emphasizeWallets = false, country = null }) {
  // Only render badges for schemes that Stripe actually charges on this account.
  // mada and K-NET are NOT enabled — showing them was misleading and could erode
  // UAE/GCC buyer trust at checkout. Re-add them ONLY if a real local processor
  // (Geidea / Tap / Telr) is wired in for that segment.
  void country;
  return (
    <div className={`flex flex-wrap items-center justify-center gap-2 sm:gap-3 ${className}`} data-testid="payment-badges">
      {emphasizeWallets && (
        <>
          <ApplePay />
          <GooglePay />
          <span className="text-current/20 hidden sm:inline opacity-30">|</span>
        </>
      )}
      <Visa />
      <Mastercard />
      <Amex />
      {!emphasizeWallets && (
        <>
          <ApplePay />
          <GooglePay />
        </>
      )}
    </div>
  );
}
